export const PASSWORD_REGEX =
    /(?=[A-Za-z0-9@*#$%^&+!=(){}\|;'":?_/<>.,`~-]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[*@#$%^&+!=(){}\|;'":?_/<>.,`~-])(?=.{8,}).*$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._-]+(@{1})[a-zA-Z0-9.-]+\.[a-zA-Z]{1,5}$/;
export const PHONE_REGEX = /^\+?[0-9]+$/;

export const STATIC_PAGE_SLUGS = {
    CGW_HOME: 'home',
    AIRPORT_AND_TRAVEL_ENHANCEMENT: 'airport-and-travel-enhancement',
    INSURANCE_AND_PROTECTION: 'insurance-and-protection',
    LOYALTY_AND_CUSTOMER_ENGAGEMENT: 'loyalty-and-customer-engagement',
    OUR_LEADERSHIP: 'our-leadership',
    OUR_OFFICES: 'our-offices',
    CASE_STUDIES: 'case-studies',
    INSIGHTS: 'insights',
    PARTNERHUB_HOME_PAGE: 'clienthub',
    PARTNERHUB_PROFILE_SLUG: 'clienthub/profile',
    PARTNERHUB_SEARCH_PAGE_SLUG: 'clienthub/search',
    PARTNERHUB_APPLY_PAGE_SLUG: 'clienthub/apply',
    PARTNERHUB_LOGIN_PAGE_SLUG: 'clienthub/login',
    PARTNERHUB_RESET_PASS_PAGE_SLUG: 'clienthub/password-manager',
};

export const MENU_IDS = {
    'priority-pass': 'priority-pass-menu',
    'loungekey': 'lounge-key-menu',
    'loungekey-pass': 'loungekey-pass-menu',
    'priority-pass,loungekey': 'priority-pass-lounge-key-menu',
    'main': 'main-menu',
} as const;

export const API_ASSET_ROUTE = '/assets/';

export const NO_LABEL_IN_THE_CONTENTFUL = 'NO LABEL IN THE CONTENTFUL';

export const HOME_PAGE_SEO_TITLE = 'CGW Home SEO';
